import { render, staticRenderFns } from "./BaseCarousel.vue?vue&type=template&id=7acaf4ca&scoped=true&"
import script from "./BaseCarousel.vue?vue&type=script&lang=js&"
export * from "./BaseCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acaf4ca",
  null
  
)

export default component.exports